import React from 'react';
import StyleSheetRW from 'core/StyleSheetRW';
import { ActivityIndicator } from 'react-native';
import { Dimensions } from 'react-native';
import { MOBILE_VIEW_WIDTH } from 'res/constants';
const Loader: React.FC = () => {
    const screenWidth=Dimensions.get('window').width;
    const styles = StyleSheetRW.create(() => ({
        loaderContainer: {
            position: 'absolute',
            top: 0,
            left: screenWidth<=MOBILE_VIEW_WIDTH?0:270,
            width:'100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
        },
    }));

    return (
        <div style={styles.loaderContainer}>
            <ActivityIndicator
                style={{left:screenWidth<=MOBILE_VIEW_WIDTH?'0%':'-10%'}}
                size="large"
                color="#2F4858"
              />
        </div>
    );
};

export default Loader;
